import React, { useState } from "react";
import "./App.css";
import { seedApps } from "./data/mockData";
import LoginScreen from "./pages/LoginScreen";
import { Sidebar, Topbar } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ApplicationsList from "./pages/ApplicationsList";
import ApplicationDetail from "./pages/ApplicationDetail";
import AwardPage from "./pages/AwardPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";

export default function App() {
  const [apps] = useState(() => seedApps());
  const [appsState, setAppsState] = useState(() => apps);
  const [loggedIn, setLoggedIn] = useState(
    !!localStorage.getItem("token")
  );
  const role = "प्रशासक";
  const [page, setPage] = useState("dashboard");
  const [activeId, setActiveId] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  function updateApp(updated) {
    setAppsState((prev) =>
      prev.map((a) => (a.id === updated.id ? updated : a)),
    );
  }
  function openDetail(id) {
    console.log("openDetail called with:", id);
    setActiveId(id);
    setPage("detail");
  }
  function goAdjacent(dir) {
    const idx = appsState.findIndex((a) => a.id === activeId);
    const next = appsState[idx + dir];
    if (next) setActiveId(next.id);
  }

  if (!loggedIn) {
    return <LoginScreen onLogin={() => setLoggedIn(true)} />;
  }

  const activeApp = appsState.find((a) => a.id === activeId);

  return (
    <div
      className="min-h-screen bg-slate-100 flex font-sans"
      style={{ fontFamily: "'Noto Sans Devanagari','Inter',sans-serif" }}
    >
      <Sidebar
        page={page}
        setPage={setPage}
        role={role}
        onLogout={() => {
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          setLoggedIn(false);
        }}
        mobileOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
      <div className="flex-1 min-w-0">
        <Topbar page={page} onMenuClick={() => setMobileMenuOpen(true)} />
        {page === "dashboard" && (
          <Dashboard apps={appsState} role={role} onOpen={openDetail} />
        )}
        {page === "applications" && (
          <ApplicationsList apps={appsState} onOpen={openDetail} />
        )}
        {page === "award" && <AwardPage apps={appsState} />}
        {page === "reports" && <ReportsPage />}
        {page === "users" && <UsersPage />}
        {page === "detail" && (
          <ApplicationDetail
            applicationId={activeId}
            onBack={() => setPage("applications")}
            onAdjacent={goAdjacent}
          />
        )}
      </div>
    </div>
  );
}
